import { reduceAction } from '../helpers';

import types from './types';

const initialState = () => ({
    initialized: false,
});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case types.SET_INITIALIZED:
            return reduceAction(state, 'initialized', action.payload);

        case types.SET_SEGMENT_ID:
            return {
                ...state,
                settings: { ...state.settings, segmentId: action.payload },
            };

        case types.SET_SETTINGS:
            return reduceAction(state, 'settings', action.payload);

        default:
            return state;
    }
};

export default reducers;
